module.exports = __webpack_public_path__ + "static/media/loading.754d6c73.svg";